import Background from 'components/common/Background';
import { SERVICE_DASHBOARD_ERROR_INDEXES } from 'lib/constant/service';
import { boxStyle, inputStyle } from 'lib/styles/index';
import styled from 'styled-components';
import SpaceBox from 'components/service/SpaceBox';
import NotiBox from 'components/service/NotiBox';
import useServiceDashboard from 'hooks/service/useServiceDashboard';
import Loading from 'components/common/Loading';
import ErrorNoti from 'components/common/ErrorNoti';
import { useState } from 'react';
import StoreSearchBox from 'components/service/StoreSearchBox';
import { VERSION } from 'lib/constant/index';
import ControllerListModal from 'components/service/ControllerListModal';
import TempNotiListModal from 'components/service/TempNotiListModal';
import Datepicker from './Datepicker';

const ErrorListType = {
  OCCUR: 'OCCUR',
  DONE: 'DONE',
};

const ErrorListLabel = {
  [ErrorListType.OCCUR]: '장애 발생 현황',
  [ErrorListType.DONE]: '장애 조치 이력',
};

const ServiceDashboard = () => {
  const startDateDefault = new Date();
  startDateDefault.setMonth(startDateDefault.getMonth() - 6);
  const [focused, setFocused] = useState(false);
  const [errorListTitle, setErrorListTitle] = useState(
    ErrorListLabel[ErrorListType.OCCUR],
  );
  const [errorType, setErrorType] = useState(0);
  const [showControllerModal, setShowControllerModal] = useState(false);
  const [showTempNotiModal, setShowTempNotiModal] = useState(false);
  const [startDate, setStartDate] = useState(new Date(startDateDefault));
  const [endDate, setEndDate] = useState(new Date());

  const {
    storeSearchWord,
    getDashboardCountsQuery,
    dashboardCounts,
    getStoreListQuery,
    storeList,
    getStoreControllerListQuery,
    controllerList,
    onChange,
  } = useServiceDashboard();

  const onShowModal = e => {
    const type = e.target.dataset.type;

    if (type === 'controller') {
      setShowControllerModal(true);
    } else if (type === 'temp-noti') {
      setShowTempNotiModal(true);
    }
  };

  if (
    getDashboardCountsQuery.isLoading ||
    getDashboardCountsQuery.error?.response.status === 401 ||
    getDashboardCountsQuery.error?.response.data.error ===
      'AuthorizationNotFound' ||
    getStoreListQuery.isLoading ||
    getStoreListQuery.error?.response.status === 401 ||
    getStoreListQuery.error?.response.data.error === 'AuthorizationNotFound' ||
    getStoreControllerListQuery.isLoading ||
    getStoreControllerListQuery.error?.response.status === 401 ||
    getStoreControllerListQuery.error?.response.data.error ===
      'AuthorizationNotFound'
  )
    return <Loading />;
  if (
    getDashboardCountsQuery.error?.response.status === 500 ||
    getStoreListQuery.error?.response.status === 500 ||
    getStoreControllerListQuery.error?.response.status === 500
  )
    return <ErrorNoti />;

  return (
    <Background>
      {showControllerModal && (
        <ControllerListModal onClose={() => setShowControllerModal(false)} />
      )}
      {showTempNotiModal && (
        <TempNotiListModal onClose={() => setShowTempNotiModal(false)} />
      )}
      <ServiceDashboardBlock>
        <div className="block-left">
          <div className="title">대시보드</div>
          <div className="dashboard-box" onClick={onShowModal}>
            <div className="dashboard-box-cell">
              <div>매장 수</div>
              <span data-type="store">
                {dashboardCounts?.storeInfo.storeCount}
              </span>
            </div>
            <div className="dashboard-box-cell">
              <div>운행 중 / 전체</div>
              <span data-type="controller">{`${dashboardCounts?.storeInfo.ActivateDeviceCount} / ${dashboardCounts?.storeInfo.deviceCount}`}</span>
            </div>
            <div className="dashboard-box-cell">
              <div>온도 알림</div>
              <span data-type="temp-noti">
                {dashboardCounts?.storeInfo.faultTempHumiCount}
              </span>
            </div>
          </div>
          <div className="block-header">
            <div className="title">{controllerList?.store}</div>
            {controllerList && (
              <StyledInput
                type="text"
                placeholder="장소를 입력하세요"
                value={storeSearchWord}
                onChange={onChange}
                onFocus={() => setFocused(true)}
              />
            )}
            {focused && (
              <StoreSearchBox storeList={storeList} setFocused={setFocused} />
            )}
          </div>
          <div className="space-box-wrapper">
            {controllerList?.spaceList
              ?.filter(el => el.controllerList.length !== 0)
              .map(space => (
                <SpaceBox key={space.id} space={space} />
              ))}
          </div>
        </div>
        <div className="block-right">
          <div className="title">장애</div>
          <div className="box">
            <div className="error-box-row">
              {SERVICE_DASHBOARD_ERROR_INDEXES.map(index => (
                <div key={index} className="error-box-row-cell">
                  {index}
                </div>
              ))}
            </div>
            <div className="error-box-row">
              <div
                className="error-box-row-cell error-number"
                data-name="OCCUR"
                onClick={e => {
                  setErrorListTitle(ErrorListLabel[e.target.dataset.name]);
                  setErrorType(0);
                }}
              >
                {dashboardCounts?.error.faultCount}
              </div>
              <div
                className="error-box-row-cell error-number"
                data-name="DONE"
                onClick={e => {
                  setErrorListTitle(ErrorListLabel[e.target.dataset.name]);
                  setErrorType(1);
                }}
              >
                {dashboardCounts?.error.doneCount}
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 15,
            }}
          >
            <div className="error-list-title">{errorListTitle}</div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ fontSize: 13, marginRight: 5, fontWeight: 'bold' }}>
                기간 검색
              </div>
              <Datepicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />
            </div>
          </div>
          <NotiBox
            errorType={errorType}
            startDate={startDate}
            endDate={endDate}
          />
          <Version>버전 {VERSION}</Version>
        </div>
      </ServiceDashboardBlock>
    </Background>
  );
};

export default ServiceDashboard;

const Version = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
`;

const ServiceDashboardBlock = styled.div`
  width: 1080px;
  margin: 0 auto;
  padding: 2rem 0;
  display: flex;
  justify-content: space-between;

  .dashboard-box {
    ${boxStyle}
    margin-top: 1rem;
    padding: 2rem;
    display: flex;
    justify-content: space-between;
  }

  .dashboard-box-cell {
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      margin-bottom: 15px;
    }

    span {
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;
    }
  }

  .dashboard-box-cell:first-child {
    span {
      text-decoration: none;
      cursor: default;
    }
  }

  .error-number {
    cursor: pointer;
    text-decoration: underline;
  }

  .block-left {
    width: 65%;
    display: flex;
    flex-direction: column;
  }

  .block-right {
    width: 30%;
    display: flex;
    flex-direction: column;
  }

  .block-header {
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .title {
    font-size: 1.3rem;
    font-weight: bold;
    letter-spacing: 4px;
  }

  .error-list-title {
    font-size: 16px;
    font-weight: bold;
  }

  .box {
    ${boxStyle}
    margin-top: 1rem;
    padding: 2rem 3rem;
    flex-direction: column;
  }

  .row {
    height: 70px;
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .cell {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .error-box-row {
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }

  .error-box-row:last-child {
    margin-bottom: 0;
  }

  .error-box-row-cell {
    width: 100%;
    text-align: center;
  }

  .space-box-wrapper {
    margin-top: 1rem;
    display: inline-flex;
    flex-wrap: wrap;
    gap: 21px;
  }
`;

const StyledInput = styled.input`
  ${inputStyle}
  width: 50%;
  height: 100%;
`;
